import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import { useTranslation } from '../../../src/i18n';
import { colors, fontSize } from '../../../constants/styleConstants';
import TitledBlock from '../../../components/TitledBlock';
import { isCustomProductionName } from '../../../utils/common';
import OriginalName from '../../../components/OriginalName';
import { TP } from '../../../constants/consts';

const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'flex',
    border: `1px solid ${colors.linesGray}`,
    backgroundColor: colors.background.grayLight,
    padding: '17px 12px',
    marginTop: '-15px',
    flexWrap: 'wrap',
  },
  item: {
    marginRight: '26px',
    '& [color="lightTitle"]': {
      fontWeight: 'normal',
    },
  },
  text: {
    fontSize: fontSize.basic,
    color: colors.cancelButton,
  },
}));

const getHeaderData = prod => [
  {
    title: `${TP}.FN_PRODUCTION_TITLE`,
    text: isCustomProductionName(prod) ? prod?.name : '',
  },
  { title: `${TP}.m_COMPOSER`, text: prod?.work?.composer?.name || '' },
  {
    title: `${TP}.m_MUSICALWORK`,
    text: prod.work ? <OriginalName name={prod?.work?.name} originalName={prod?.work?.original_name} /> : '',
  },
  { title: `${TP}.m_FESTIVAL`, text: prod.festival?.name },
];

const StepHeader = ({ production, noWrapper, className }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <div className={cn(className, { [classes.wrapper]: !noWrapper })}>
      {getHeaderData(production).map(
        (headerItem, index) =>
          headerItem?.text && (
            <TitledBlock
              key={index}
              title={t(headerItem.title)}
              titleSize="regular"
              titleColor="lightTitle"
              className={classes.item}
            >
              <div className={classes.text}>{headerItem.text}</div>
            </TitledBlock>
          ),
      )}
    </div>
  );
};

StepHeader.propTypes = {
  production: PropTypes.object.isRequired,
  noWrapper: PropTypes.bool,
  className: PropTypes.string,
};

StepHeader.defaultProps = {
  noWrapper: false,
  className: '',
};

export default StepHeader;
